import { BackendModel, BackendService } from "../../../core/backend.service";

export class ProductosBuscadoHistorial extends BackendModel {

    static path:string = '/new-productos/';
    texto:string;
    encuentraProductos: boolean;


  constructor(protected backendService: BackendService, model?: ProductosBuscadoHistorial) {
      super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/productos-buscados/models/producto-buscado-historial.model.ts